import { render, staticRenderFns } from "./LoyaltyOverallStats.vue?vue&type=template&id=1fc597cd"
import script from "./LoyaltyOverallStats.vue?vue&type=script&lang=js"
export * from "./LoyaltyOverallStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports